<p>
  manage-calendar works!
</p>
